import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9grp69f3nm: FaireBrandEntity = {
  token: "b_9grp69f3nm",
  type: "brand",
  name: "Hydroponic",
  avatarUrl:
    "https://cdn.faire.com/fastly/d18dab03369aafb2bdc851d4751cd585b7580cb646b6adbaa6f446db953aa8cd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fea5aa6ffae6c6ace748905babb025394eb68cb44524c53a47a3e87277cccbe2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d18dab03369aafb2bdc851d4751cd585b7580cb646b6adbaa6f446db953aa8cd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fea5aa6ffae6c6ace748905babb025394eb68cb44524c53a47a3e87277cccbe2.png",
  location: "ESP",
  minimumOrderDollars: 0,
  rating: 4.6,
  reviewCount: 11,
  isInsider: false,
  description:
    "We started Hydroponic in 2002 in Barcelona, Spain, as a clothing line since there were barely any surf and skate apparel brands around creating local boarding culture with attractive designs and quality products devoted to surfing & skateboarding, and offering a somehow different approach than the big companies.\n \nSince then, we have been creating 2 Clothing and Skateboarding Collections every year, where we are currently being distributed close to 20 countries. We sponsor some of the best skaters in the country, as well as surfers and longboarders, and artists and creators.\n \nAs part of our Collections, we regularly collaborate with different brands. In the last 10 years we have collaborated with top companies like rolling paper giants Smoking, graffiti powerhouse Montana Colors, local Barcelona deluxe brewers Moritz, world leaders in gas lighters Clipper, and Self Surfboards & Hav Surfboards, Basque and Barcelona famous Local surf shapers.\nNowadays, we focus on our official co-branding with international comic book icons like Mortadelo and Filemón, the most famous Spanish cartoon, Dr Slump, Pink Panther, South Park and Dragon Ball.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.231Z",
    importedBy: "entity-db-cli",
  },
};
